module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "financeSetA"
  }, [_c('div', {
    staticClass: "navCalss"
  }, [_vm._v("| 创建订单")]), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('el-form', {
    ref: "netBarForm",
    staticStyle: {
      "width": "auto"
    },
    attrs: {
      "model": _vm.order,
      "rules": _vm.order.form_rules,
      "label-width": "95px",
      "label-position": "left"
    }
  }, [_c('div', {
    staticClass: "flex2"
  }, [_c('div', {
    staticClass: "font"
  }, [_vm._v("基本信息")]), _vm._v(" "), _c('div', {
    staticClass: "btn"
  })]), _vm._v(" "), _c('div', {
    staticClass: "lineBorder"
  }), _vm._v(" "), _c('div', {
    staticClass: "flex1"
  }, [_c('div', {
    staticClass: "flexLeft"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "vipCode",
      "label": "客户VIP号 :"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "208px"
    },
    attrs: {
      "placeholder": "请输入客户VIP号"
    },
    on: {
      "focus": function($event) {
        return _vm.showDialog()
      }
    },
    model: {
      value: (_vm.order.vipCode),
      callback: function($$v) {
        _vm.$set(_vm.order, "vipCode", $$v)
      },
      expression: "order.vipCode"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "flexRight"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "predictTotal",
      "label": "商品价值 :"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "208px"
    },
    attrs: {
      "placeholder": "整单商品价值,单位元"
    },
    model: {
      value: (_vm.order.predictTotal),
      callback: function($$v) {
        _vm.$set(_vm.order, "predictTotal", $$v)
      },
      expression: "order.predictTotal"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "flex1"
  }, [_c('div', {
    staticClass: "flexLeft"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "expressCompany",
      "label": "快递公司 :"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "208px"
    },
    attrs: {
      "placeholder": "请输入快递公司",
      "filterable": ""
    },
    model: {
      value: (_vm.order.expressCompany),
      callback: function($$v) {
        _vm.$set(_vm.order, "expressCompany", $$v)
      },
      expression: "order.expressCompany"
    }
  }, _vm._l((_vm.deliveyList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.name
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "flexRight"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "checkedGoodsType",
      "label": "货运类型 :"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "208px"
    },
    attrs: {
      "placeholder": "请选择货运类型"
    },
    model: {
      value: (_vm.order.checkedGoodsType),
      callback: function($$v) {
        _vm.$set(_vm.order, "checkedGoodsType", $$v)
      },
      expression: "order.checkedGoodsType"
    }
  }, _vm._l((_vm.goodsType), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.value,
        "value": item.id
      }
    })
  }), 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "flex1"
  }, [_c('div', {
    staticClass: "flexLeft"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "expressNo",
      "label": "快递单号:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "208px"
    },
    attrs: {
      "placeholder": "请输入快递单号"
    },
    model: {
      value: (_vm.order.expressNo),
      callback: function($$v) {
        _vm.$set(_vm.order, "expressNo", $$v)
      },
      expression: "order.expressNo"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "flexRight"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "remark",
      "label": "订单备注:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "208px"
    },
    attrs: {
      "placeholder": "选填"
    },
    model: {
      value: (_vm.order.remark),
      callback: function($$v) {
        _vm.$set(_vm.order, "remark", $$v)
      },
      expression: "order.remark"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "flex2"
  }, [_c('div', {
    staticClass: "font"
  }, [_vm._v("商品清单")]), _vm._v(" "), _c('div', {
    staticClass: "btn"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.addProduct()
      }
    }
  }, [_vm._v("\n              添加商品")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "lineBorder"
  }), _vm._v(" "), _vm._l((_vm.order.detailList), function(value, index) {
    return _c('div', {
      key: index
    }, [_c('div', {
      staticClass: "flex3"
    }, [_c('div', [_vm._v("\n              " + _vm._s(index + 1) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "line"
    }, [_c('el-form-item', {
      staticStyle: {
        "margin-left": "-55px"
      },
      attrs: {
        "prop": 'detailList.' + index + '.productName',
        "rules": [{
          required: true,
          message: '商品名称不能为空',
          trigger: 'blur',
        } ]
      }
    }, [_c('el-input', {
      staticStyle: {
        "width": "400px"
      },
      attrs: {
        "placeholder": "请输入商品名称"
      },
      model: {
        value: (value.productName),
        callback: function($$v) {
          _vm.$set(value, "productName", $$v)
        },
        expression: "value.productName"
      }
    })], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "line"
    }, [_c('el-form-item', {
      staticStyle: {
        "margin-left": "-75px"
      },
      attrs: {
        "prop": 'detailList.' + index + '.productNum',
        "rules": [{
            required: true,
            message: '商品数量不能为空',
            trigger: 'blur',
          },
          {
            type: 'number',
            message: '商品数量必须为数字值'
          } ]
      }
    }, [_c('el-input', {
      staticStyle: {
        "width": "120px"
      },
      attrs: {
        "placeholder": "商品数量"
      },
      model: {
        value: (value.productNum),
        callback: function($$v) {
          _vm.$set(value, "productNum", _vm._n($$v))
        },
        expression: "value.productNum"
      }
    })], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "line",
      staticStyle: {
        "margin-left": "25px"
      }
    }, [(_vm.order.detailList.length > 1) ? _c('el-button', {
      attrs: {
        "type": "text"
      },
      on: {
        "click": function($event) {
          return _vm.deleteDialog(index)
        }
      }
    }, [_vm._v("删除")]) : _vm._e()], 1)])])
  })], 2)], 1), _vm._v(" "), _c('div')]), _vm._v(" "), _c('div', {
    staticClass: "flex4"
  }, [_c('div', [_c('el-button', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.onSubmit()
      }
    }
  }, [_vm._v("提交")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.adminDeleteDialog.show,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "340px",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.adminDeleteDialog, "show", $event)
      }
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', [_vm._v("您确定移除该商品信息嘛？")])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.deleteItem(_vm.indexA)
      }
    }
  }, [_vm._v("删除")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.adminDeleteDialog.show = false
      }
    }
  }, [_vm._v("取 消")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.adminDeleteDialog.showB,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "1000px",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.adminDeleteDialog, "showB", $event)
      }
    }
  }, [_c('div', {
    staticClass: "minWidth"
  }, [_c('el-form', {
    ref: "search_data",
    staticClass: "demo-form-inline search-form",
    attrs: {
      "inline": true
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "客户名称:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "placeholder": "请输入客户名称",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getCustomer()
      }
    },
    model: {
      value: (_vm.searchData.keyWordB),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "keyWordB", $$v)
      },
      expression: "searchData.keyWordB"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "昵称:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "placeholder": "请输入昵称",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getCustomer()
      }
    },
    model: {
      value: (_vm.searchData.keyWord),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "keyWord", $$v)
      },
      expression: "searchData.keyWord"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "手机号:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "placeholder": "请输入手机号",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getCustomer()
      }
    },
    model: {
      value: (_vm.searchData.keyWordC),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "keyWordC", $$v)
      },
      expression: "searchData.keyWordC"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-button', {
    staticStyle: {
      "margin-left": "50px"
    },
    attrs: {
      "type": "primary",
      "icon": "search"
    },
    on: {
      "click": function($event) {
        return _vm.getCustomer()
      }
    }
  }, [_vm._v("搜索")])], 1)], 1), _vm._v(" "), _c('el-row')], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "table_container"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.customerList,
      "border": "",
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "adminId",
      "label": "序号",
      "align": "center",
      "min-width": "50px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          domProps: {
            "textContent": _vm._s(_vm.getIndex(scope.$index))
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "用户名",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "wrl-flex",
          attrs: {
            "align": "center"
          }
        }, [_c('div', {
          staticClass: "wrl-name"
        }, [_vm._v("\n                " + _vm._s(scope.row.nickname) + "\n              ")])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "真实姓名",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.realName) ? _c('div', [_vm._v(_vm._s(scope.row.realName))]) : _c('div', [_vm._v("无")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "联系方式",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "wrl-flex",
          attrs: {
            "align": "center"
          }
        }, [_c('div', {
          staticClass: "wrl-name"
        }, [_vm._v("\n                " + _vm._s(scope.row.mobile) + "\n              ")])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "VIP号",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(scope.row.vipCode) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.seleVipCode(scope.row.vipCode)
            }
          }
        }, [_vm._v("选择")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "paginationC"
  }, [_c('el-pagination', {
    attrs: {
      "page-sizes": _vm.paginations.page_sizes,
      "page-size": _vm.paginations.page_size,
      "layout": _vm.paginations.layout,
      "total": _vm.paginations.total,
      "current-page": _vm.paginations.page_index
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange
    }
  })], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fbd83d04"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/order/addOrder.vue
// module id = 1268
// module chunks = 2